import { apiBaseUrl } from '@eshhanle/shared';
import { str } from '@/utils/format';

/**
 * Resolve product/slide/upload paths for dashboard + API split hosts.
 * Absolute URLs pass through; /uploads|images|assets|storage go via API/dashboard origin.
 */
export function mediaUrl(raw: unknown): string {
  const t = str(raw, '').trim();
  if (!t || t === '—') return '';
  if (/^(https?:|data:|blob:)/i.test(t)) return t;
  if (t.startsWith('//')) return `https:${t}`;

  const path = t.replace(/^\/+/, '');
  const mediaRoots = ['uploads/', 'images/', 'assets/', 'storage/'];
  if (mediaRoots.some((root) => path.startsWith(root))) {
    const api = apiBaseUrl(import.meta.env.VITE_API_BASE);
    const origin = api.replace(/\/api\/?$/, '');
    if (origin && /^https?:\/\//i.test(origin)) {
      return `${origin.replace(/\/$/, '')}/${path}`;
    }
    // Same-origin dashboard (/api) — prefer media.php so files under API public root still resolve.
    if (typeof window !== 'undefined' && path.startsWith('uploads/')) {
      return `/media.php?file=${encodeURIComponent(path.slice('uploads/'.length))}`;
    }
    return `/${path}`;
  }
  return `/${path}`;
}
